import React from "react";

import BaseSvg, { BaseSvgProps } from "../../BaseSvg";

const EnchantmentSvg: React.FunctionComponent<BaseSvgProps> = ({
  className = "",
  fillColor,
  secondaryFillColor,
}) => {
  return (
    <BaseSvg className={className} viewBox="0 0 60 60">
      <path
        fill={fillColor}
        d="M46 25.6c-2.8.2-6.4 4-6.7 6.7q0 .9.5 1t.8-.1l1.5-1.9a8 8 0 0 1 3.3-2.7q1.8-.6 3 .7 1.3 1.2 1 2.9 0 1.5-.6 3-3 6.9-9.1 11-3 2-6.6 2-1.9 0-3-1.6l-1.9-3.4-1.7-3.6 2.8-3.3a45 45 0 0 0 7.3-11.8q1.4-3.3 1.2-7-.4-4.6-4.7-6a7 7 0 0 0-6.4.9A13 13 0 0 0 22 18l-.7 1.8q-.5.7-1.3.1l-.5-.7a41 41 0 0 1-5.4-11Q14 8 13.5 8l-.2.3-.1 1.7v24.3q0 1.7-1.4 2.5L10.2 38Q9 39 7.7 40.2c-.2.2-.3 1 0 1.3q.6.4 1 .2 1.4-.5 2.7-1.2c1.5-.8 1.8-.7 2 1.1q0 1.8.4 3.6 0 .6.4 1.1.1.5.8.7.5-.1.6-.6.3-.6.4-1.2.4-3 .5-6 0-2.3 1.8-3.5 1.5-1.2 2.9-2.6.2-.5 0-1a1 1 0 0 0-1-.2l-2.4 1q-1.2.4-1.2-.8v-9.4c0-.3 0-1 .5-.8.3 0 1.7 2.3 5 4.5q1.1.8 1.5-.6l.2-1.4c.3-1.9 1.4-4.2 2.3-5.9a9 9 0 0 1 3.2-3.2c1.9-1.1 4.8-.1 4.8 2.7q0 1.5-.4 3-1.6 5.3-4.7 9.7a51 51 0 0 1-7.4 8.5c-1.1 1-1.1 1.3.2 1.8q2 1 2.9 3l1.9 3.7c2 3.4 5.3 4.8 9.1 3.8Q38 51.1 40 50q7.7-4.5 11.4-12.5 1.5-3.4.9-7a6 6 0 0 0-6.3-4.8"
      />
    </BaseSvg>
  );
};

export default EnchantmentSvg;
